var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.classes,attrs:{"src":"/assets/favicons/favicon-32x32.png","alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }